define('presentation/settings/billing/plans/viewModels/addCustomPlanActionModalViewModel',[
    'common/promises/promiseFactory',
    'presentation/common/window/windowControl',
], function () {
    return function () {
        let self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _windowControl = require('presentation/common/window/windowControl');

        self.onScheduleConsultationClicked = () => {
            _windowControl.openNewWindow("https://hello.patlive.com/meetings/patlive/salesteam");
        };

        self.activate = () => {
            return _initialize();
        };

        const _initialize = () => {
            return _promiseFactory.wait();
        };
    };
});
